<div class="p-dialog-content-wrapper">
	<h4>Verifique os pontos abaixo para continuar:</h4>

	<ul class="list__container">
		<ng-container *ngIf="dialogData.invalidItems?.length">
			<ng-container *ngFor="let item of dialogData?.invalidItems">
				<li class="list__item" *ngFor="let message of item.messages">
					{{ message }}
				</li>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="dialogData.messages?.length">
			<li class="list__item" *ngFor="let message of dialogData?.messages">
				{{ message }}
			</li>
		</ng-container>
	</ul>
</div>

<div class="p-dialog-footer">
	<p-button
		label="{{
			dialogData?.action === 'buyCart' ? 'Atualizar carrinho' : 'Ok'
		}} "
		(onClick)="onClose(true)"
	></p-button>
</div>
